export const getCurrency = () => window[window.config.padl.namespace].dataLayer.app.app.currency
